import React, { type ComponentPropsWithoutRef } from 'react';
import { styled } from '@compiled/react';
import Heading from '@atlaskit/heading';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import { DeploymentsTrendSummary } from '../../../common/ui/trend-summary/index.tsx';
import messages from './messages.tsx';
import type { Props } from './types.tsx';

export const SelectionDetail = ({
	weekCount,
	weekStartDate,
	wholePeriodAverage,
	prodDataState,
}: Props) => {
	const { formatMessage, formatDate } = useIntl();
	const weekStartDateText = formatMessage(messages.weekStartDate, {
		date: formatDate(weekStartDate, { day: 'numeric', month: 'short' }),
	});

	return (
		<>
			<WeekStartDate>{weekStartDateText}</WeekStartDate>
			<DeploymentCount>{weekCount}</DeploymentCount>
			<WeeklyProductionDeployments>
				{formatMessage(messages.weeklyProductionDeployment, { deploymentCount: weekCount })}
			</WeeklyProductionDeployments>
			<DeploymentsTrendSummary
				weekCount={weekCount}
				wholePeriodStatistic={wholePeriodAverage}
				prodDataState={prodDataState}
			/>
		</>
	);
};

const WeekStartDate = (props: ComponentPropsWithoutRef<typeof WeekStartDateComponent>) => (
	<Heading size="medium" as="div">
		<WeekStartDateComponent {...props} />
	</Heading>
);

const DeploymentCount = (props: ComponentPropsWithoutRef<typeof DeploymentCountComponent>) => (
	<Heading size="xlarge" as="div">
		<DeploymentCountComponent {...props} />
	</Heading>
);

const WeeklyProductionDeployments = (
	props: ComponentPropsWithoutRef<typeof WeeklyProductionDeploymentsComponent>,
) => (
	<Heading size="xxsmall" as="div">
		<WeeklyProductionDeploymentsComponent {...props} />
	</Heading>
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const WeekStartDateComponent = styled.div({
	color: token('color.text'),
	marginTop: token('space.400'),
	marginBottom: token('space.100'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const DeploymentCountComponent = styled.div({
	color: token('color.text'),
	marginTop: token('space.0'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const WeeklyProductionDeploymentsComponent = styled.div({
	color: token('color.text.subtle'),
	marginTop: token('space.0'),
	marginBottom: token('space.100'),
});
